import {
    IPublicClientApplication,
    createStandardPublicClientApplication,
    EventType,
    EventMessage,
    AccountInfo,
} from "@azure/msal-browser";
import config, { isMsal } from "../config";

async function createInstance(): Promise<IPublicClientApplication> {
    const instance = await createStandardPublicClientApplication({
        auth: { ...config.msal, clientId: config.msal.clientId! },
    });

    if (!instance.getActiveAccount() && instance.getAllAccounts().length > 0) {
        instance.setActiveAccount(instance.getAllAccounts()[0]);
    }

    instance.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_SUCCESS) {
            const payload = event.payload as { account?: AccountInfo } | null;
            if (payload?.account) {
                instance.setActiveAccount(payload.account);
            }
        }
    });

    return instance;
}

export const msalReady: Promise<IPublicClientApplication> | null = isMsal ? createInstance() : null;
